export default (node) => {
  const accordionItems = node.querySelectorAll('[data-accordion-item]');
  let activeItem = null;

  const isTextClamped = (element) => {
    return element.scrollHeight > element.clientHeight;
  };

  const openAccordion = (item, content, expandIcon, collapseIcon) => {
    content.setAttribute('aria-hidden', 'false');
    expandIcon.classList.add('hidden');
    collapseIcon.classList.remove('hidden');
    const button = item.querySelector('[data-accordion-button]');
    if (button) button.setAttribute('aria-expanded', 'true');
  };

  const closeAccordion = (item, content, expandIcon, collapseIcon) => {
    content.setAttribute('aria-hidden', 'true');
    expandIcon.classList.remove('hidden');
    collapseIcon.classList.add('hidden');
    const button = item.querySelector('[data-accordion-button]');
    if (button) button.setAttribute('aria-expanded', 'false');
  };

  const toggleAccordion = (item, content, expandIcon, collapseIcon) => {
    // Close any other open accordion
    if (activeItem && activeItem.item !== item) {
      closeAccordion(
        activeItem.item,
        activeItem.content,
        activeItem.expandIcon,
        activeItem.collapseIcon
      );
    }

    // Close accordion if it is already open
    if (activeItem && activeItem.item === item) {
      closeAccordion(item, content, expandIcon, collapseIcon);
      activeItem = null;
      return;
    }

    // Open accordion
    openAccordion(item, content, expandIcon, collapseIcon);
    activeItem = {
      item,
      content,
      expandIcon,
      collapseIcon,
    };
  };

  const initReadMoreButton = (innerContent, readMoreButton) => {
    if (isTextClamped(innerContent)) {
      readMoreButton.classList.remove('hidden');
      readMoreButton.addEventListener('click', () => {
        if (innerContent.classList.contains('line-clamp-none')) {
          innerContent.classList.remove('line-clamp-none');
          readMoreButton.textContent = readMoreButton.dataset.readMoreText;
          return;
        }

        innerContent.classList.add('line-clamp-none');
        readMoreButton.textContent = readMoreButton.dataset.readLessText;
      });
    }
  };

  const initAccordionItem = (item) => {
    const button = item.querySelector('[data-accordion-button]');
    const content = item.querySelector('[data-accordion-content]');
    const expandIcon = item.querySelector('[data-expand-icon]');
    const collapseIcon = item.querySelector('[data-collapse-icon]');
    const innerContent = item.querySelector('[data-inner-content]');
    const readMoreButton = item.querySelector('[data-read-more-button]');

    if (activeItem && item.dataset.startOpen === 'true') {
      closeAccordion(item, content, expandIcon, collapseIcon);
    } else if (item.dataset.startOpen === 'true') {
      activeItem = {
        item,
        content,
        expandIcon,
        collapseIcon,
      };
    }

    // Accordion button
    button.addEventListener('click', () =>
      toggleAccordion(item, content, expandIcon, collapseIcon)
    );

    // Read more button
    initReadMoreButton(innerContent, readMoreButton);
  };

  // Initialize
  accordionItems.forEach((item) => {
    initAccordionItem(item);
  });
};
